export const THEME_SUCCESS = "success";
export const THEME_DANGER = "danger";
export const THEME_WARNING = "warning";
export const THEME_INFO = "info";
export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";

